import { changeClaimStatus, getClaim, savePrintQuoteOptions } from "../../services/apiClient.js";
import { detectMode } from "./quotePrintModes.js";

export async function printQuoteDocument({ claimId, options, openedAsSow = false, onChanged }) {
  window.print();
  // Save the layout after printing; failure must not block the paper.
  savePrintQuoteOptions(claimId, { ...options, mode: detectMode(options) }).catch(() => {});

  // Either the SOW entry point or the selected SOW document makes this print
  // status-neutral. Changing preview options cannot undo the entry-point guard.
  if (openedAsSow || options.sow) return;

  // Quote printing preserves the existing Inspected -> Quoted behaviour.
  try {
    const { claim } = await getClaim(claimId);
    if (claim.current_status_code === "I") {
      await changeClaimStatus(claimId, { to: "Q", note: "Quote printed." });
      onChanged?.();
    }
  } catch {
    // A blocked status move must not prevent printing.
  }
}
